import tracking from 'src/tracking';
import { BrandPushProps } from '../../components/molecules/BrandPush';
import type { Brand, Format } from '../../graphql/generated/api-graphql';
import routes from '../../routes/definitions';
import Router from '../../routes/Router';
import { wediaImagesTransform } from '../Common/wedia';
const BrandPushTransform = ({
  t,
  brand,
  formats,
  handlePopin
}: {
  t: any;
  brand: Brand;
  formats?: Format[];
  handlePopin?: (product: any) => void;
}): BrandPushProps => {
  // console.log(brand)
  return {
    imageProps: {
      maxWidth: 910,
      width: 408,
      height: 306,
      withHD: true,
      images: brand?.thumbnailRange ? wediaImagesTransform(brand.thumbnailRange) : undefined,
      placeholder: !brand?.thumbnailRange,
      alt: brand.thumbnailRange?.alt ?? ''
    },
    brandLogoProps: brand?.pictureLogo ? {
      maxWidth: 120,
      width: 120,
      height: 120,
      withHD: true,
      alt: brand.name ?? brand?.pictureLogo.alt ?? '',
      images: brand.pictureLogo ? wediaImagesTransform(brand.pictureLogo) : undefined
    } : undefined,
    brandLabel: t('discover_the_brand'),
    brandName: brand?.name ?? undefined,
    actionButtonProps: brand?.slug ? {
      label: t('discover'),
      href: Router.getRouteUrl(routes.brand, {
        slug: brand.slug
      }),
      onClick: () => tracking.brand.card(brand?.name, t('discover_the_brand'))
    } : undefined,
    productsProps: formats && formats.length > 0 ? formats.map(format => ({
      name: format.title,
      imageProps: {
        maxWidth: 120,
        width: 120,
        height: 120,
        withHD: true,
        images: format.thumbnail ? wediaImagesTransform(format.thumbnail) : undefined,
        alt: format.title ?? format.thumbnail?.alt ?? ''
      },
      linkProps: {
        label: format.title,
        href: format?.slug ? Router.getRouteUrl(routes.format, {
          slug: format.slug
        }) : undefined,
        onClick: handlePopin ? e => {
          e.preventDefault();
          handlePopin(format);
          tracking.brand.card(brand?.name, format.title);
        } : undefined
      },
      label: t('learn_more')
    })) : undefined
  };
};
export default BrandPushTransform;